// extracted by mini-css-extract-plugin
module.exports = {"Hero":"Hero_Hero__qbctv","VideoBG":"Hero_VideoBG__3DWoU","TextContents":"Hero_TextContents__3F0-c","Title":"Hero_Title__Y_vU0"};